import { cardsData } from '@/mocks/homeData';

const tagBgMap: Record<string, string> = {
  primary: 'bg-primary-500 text-background-50',
  accent: 'bg-accent-500 text-background-50',
  secondary: 'bg-secondary-500 text-background-50',
};

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            热门推荐
          </h2>
          <div className="w-12 h-1 bg-primary-500 rounded-full mx-auto mb-4"></div>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            精选高分好剧，总有一部适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cardsData.slice(0, 3).map((item) => (
            <div
              key={item.title}
              className="group rounded-2xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-300/40 transition-all duration-300"
            >
              <div className="relative overflow-hidden aspect-[3/2]">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <span
                  className={`absolute top-3 left-3 px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap ${tagBgMap[item.tagColor] || tagBgMap.primary}`}
                >
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading font-bold text-foreground-950 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
          {cardsData.slice(3, 5).map((item) => (
            <div
              key={item.title}
              className="group flex flex-col sm:flex-row rounded-2xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-300/40 transition-all duration-300"
            >
              <div className="relative overflow-hidden sm:w-[200px] aspect-[3/2] sm:aspect-auto shrink-0">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <span
                  className={`absolute top-3 left-3 px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap ${tagBgMap[item.tagColor] || tagBgMap.primary}`}
                >
                  {item.tag}
                </span>
              </div>
              <div className="p-5 flex flex-col justify-center">
                <h3 className="text-base font-heading font-bold text-foreground-950 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}